import { HistoryError, HistoryErrorList, ReorderAcceptableError } from '@/models/order-history/status/context/history-error'

export function filterNpProfileError(
  errorList: HistoryErrorList<HistoryError>
): HistoryErrorList<ReorderAcceptableError> {
  return errorList.onlyReorderAcceptableError.filter(e =>
    e.details.some(d => d.code.startsWith('ER'))
  )
}

export function filterNpCreditError(
  errorList: HistoryErrorList<HistoryError>
): HistoryErrorList<ReorderAcceptableError> {
  return errorList.onlyReorderAcceptableError.filter(e =>
    e.details.some(d => d.code.startsWith('NG999') || d.code.startsWith('RE'))
  )
}

export function containNpProfileError(errorList: HistoryErrorList<HistoryError>): boolean {
  return !filterNpProfileError(errorList).isEmpty
}

export function containNpCreditError(errorList: HistoryErrorList<HistoryError>): boolean {
  return !filterNpCreditError(errorList).isEmpty
}
